import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon, ArrowUpDownIcon } from 'lucide-react';
interface Column<T> {
  header: string;
  accessor: keyof T;
  sortable?: boolean;
  render?: (value: any, item: T) => React.ReactNode;
}
interface DataTableProps<T> {
  data: T[];
  columns: Column<T>[];
  onRowClick?: (item: T) => void;
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  sortColumn?: string;
  sortAscending?: boolean;
  onSort?: (column: string) => void;
}
export function DataTable<T>({
  data,
  columns,
  onRowClick,
  page,
  totalPages,
  onPageChange,
  sortColumn,
  sortAscending,
  onSort
}: DataTableProps<T>) {
  return <div className="glass-panel rounded-xl overflow-hidden flex flex-col" data-id="element-22" data-mp="1a5dpohqa3qy">
      <div className="overflow-x-auto" data-id="element-23" data-mp="3sg6hrd39zx33">
        <table className="w-full text-left text-sm text-slate-300" data-id="element-24" data-mp="1vmd5isyr64ii">
          <thead className="text-xs text-slate-400 uppercase bg-slate-900/80 border-b border-slate-800" data-id="element-25" data-mp="1vlk1w0v3bv4l">
            <tr data-id="element-26" data-mp="1ql5saeducd4g">
              {columns.map((col, idx) => <th key={idx} className={`px-6 py-4 font-semibold tracking-wider ${col.sortable ? 'cursor-pointer hover:text-slate-200' : ''}`} onClick={() => col.sortable && onSort && onSort(col.accessor as string)} data-id="element-27" data-mp="10wv1set0sl8r" data-mpi={idx}>
                  <div className="flex items-center gap-2" data-id="element-28" data-mp="w0ntifd5ixnn">
                    {col.header}
                    {col.sortable && <ArrowUpDownIcon size={14} className={sortColumn === col.accessor ? 'text-cyan-400' : 'text-slate-600'} data-id="element-29" data-mp="1omz48iuh2ey6" />}
                  </div>
                </th>)}
            </tr>
          </thead>
          <tbody data-id="element-30" data-mp="27dzzavsh1qcg">
            {data.length === 0 ? <tr data-id="element-31" data-mp="27fkxqwhwptfl">
                <td colSpan={columns.length} className="px-6 py-12 text-center text-slate-500" data-id="element-32" data-mp="2h9gntx5qwa3k">
                  No data available
                </td>
              </tr> : data.map((item, rowIndex) => <tr key={rowIndex} onClick={() => onRowClick && onRowClick(item)} className={`border-b border-slate-800/50 hover:bg-slate-800/30 transition-colors ${onRowClick ? 'cursor-pointer' : ''}`} data-id="element-33" data-mp="239xsk4y18t8o" data-mpi={rowIndex}>
                  {columns.map((col, colIndex) => <td key={colIndex} className="px-6 py-4 whitespace-nowrap" data-id="element-34" data-mp="1ok9tzbh8k8on" data-mpi={colIndex}>
                      {col.render ? col.render(item[col.accessor], item) : item[col.accessor] as React.ReactNode || '-'}
                    </td>)}
                </tr>)}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && <div className="flex items-center justify-between px-6 py-4 bg-slate-900/50 border-t border-slate-800" data-id="element-35" data-mp="3m8dix17bvydf">
          <span className="text-sm text-slate-400" data-id="element-36" data-mp="3r9jfja4405s8">
            Page{' '}
            <span className="font-semibold text-slate-200" data-id="element-37" data-mp="1x959q09p7o">{page + 1}</span> of{' '}
            <span className="font-semibold text-slate-200" data-id="element-38" data-mp="41pj9qv1s3f5">{totalPages}</span>
          </span>
          <div className="flex gap-2" data-id="element-39" data-mp="33j72jku0bius">
            <button onClick={() => onPageChange(Math.max(0, page - 1))} disabled={page === 0} className="p-2 rounded-lg bg-slate-800 text-slate-300 hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-40" data-mp="33g1d24hgueyj">
              <ChevronLeftIcon size={18} data-id="element-41" data-mp="3hbn6qoyn9mxa" />
            </button>
            <button onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))} disabled={page >= totalPages - 1} className="p-2 rounded-lg bg-slate-800 text-slate-300 hover:bg-slate-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors" data-id="element-42" data-mp="2kql9t9eec8ef">
              <ChevronRightIcon size={18} data-id="element-43" data-mp="20r33nguwnj6g" />
            </button>
          </div>
        </div>}
    </div>;
}